import $ from 'static/script/libs/jquery';
import observable from 'static/script/app/ui/checkout2/context/observable';
import modal from 'static/script/app/ui/checkout2/context/modal';
import util from 'static/script/app/ui/checkout2/context/util';

let payment = { };

observable.on('payment-confirmed-by-user', function (paymentType, paymentResponse) {
    modal.showModal('checkout-modal',
        {
            title: 'Tack!',
            text: paymentResponse.successMessage ? paymentResponse.successMessage :  'Betalningen har nu genomförts och säljaren har meddelats',
            nonDismissible: true,
            showSuccessIcon: true,
            buttons: {
                secondary: { title: 'OK', click: function () { payment.successAction(); } }
            }
        });
});

observable.on('payment-confirmed-by-user-failed', function (paymentType, failureMessage) {
    modal.showModal('checkout-modal',
        {
            title: 'Ett fel inträffade',
            text: failureMessage ? failureMessage : 'Vi kunde inte genomföra betalningen.',
            showErrorIcon: true,
            buttons: {
                secondary: { title: 'OK' }
            }
        });
});

observable.on('payment-type-selected', function (type) {
    payment.selectedPaymentType = type;
});

observable.on('payment-valid', function () {
    payment.isCheckoutValid = true;
});

observable.on('payment-not-valid', function () {
    payment.isCheckoutValid = false;
});

observable.on('braintree-payment-ready-for-submit', function (payload) {
    if (payment.deferedPrepare) {
        payment.deferedPrepare.resolve(payload);
    }
});

observable.on('braintree-payment-not-ready-for-submit', function (isAborted) {
    if (payment.deferedPrepare) {
        payment.deferedPrepare.reject(isAborted);
    }
});

observable.on('payment-set-payload', function (payload) {
    payment.paymentPayload = payload;
});

payment.initTimeoutHandling = function(timeout) {
    payment.stopTimeoutHandler();
    payment.timeoutHandlerId = setTimeout(function() {
        if (modal.currentModalModel.showProgressIcon) {
            util.serverLog({ counterName: 'confirm.timeout' });
            modal.showModal('checkout-modal',
                {
                    title: 'Åtgärden tog för lång tid',
                    text: 'Vänligen försök igen',
                    showErrorIcon: true,
                    buttons: {
                        secondary: { title: 'OK', click: function() { window.location.reload(false); } }
                    }
                });
        }
    },
    timeout);
};

payment.stopTimeoutHandler = function() {
    if (payment.timeoutHandlerId) {
        clearTimeout(payment.timeoutHandlerId);
    }
};

payment.performPayment = function(model, url) {
    if (!payment.isCheckoutValid) {
        return;
    }

    let modalDialog = modal.showModal('checkout-modal',
        {
            title: 'Genomför betalning...',
            nonDismissible: true,
            showProgressIcon: true
        });

    payment.preparePaymentForSubmit()
        .done(payment.confirmPurchase.bind(this, modalDialog, model, url))
        .fail(function(isAborted) {
            if (isAborted) {
                modalDialog.close();
            } else {
                modalDialog.showError('Ett fel har inträffat', 'Uppgifterna kunde inte verifieras');
            }
        });
};

payment.preparePaymentForSubmit = function() {
    payment.deferedPrepare = $.Deferred();

    if (payment.selectedPaymentType === 'card' || payment.selectedPaymentType === 'paypal') {
        observable.trigger('braintree-payment-prepare-for-submit');
    } else {
        payment.deferedPrepare.resolve(payment.paymentPayload);
    }

    return payment.deferedPrepare.promise();
};

payment.confirmPurchase = function(modalDialog, model, url, paymentPayload) {
    payment.initTimeoutHandling(120000);
    model.payment = paymentPayload;
    model.paymentType = payment.selectedPaymentType;

    $.ajax({
        type: 'POST',
        url: url,
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(model),
        success: payment.purchaseSuccess.bind(this, modalDialog),
        error: payment.purchaseFailed.bind(this, modalDialog)
    });
};

payment.purchaseSuccess = function(modalDialog, e) {
    payment.stopTimeoutHandler();

    if (e.success) {
        if (e.paymentRequiresUserConfirmation) {
            payment.successAction = function() { util.redirectTo(e.redirectUrl); };
            observable.trigger('payment-requires-user-confirmation', payment.selectedPaymentType, e);
        } else {
            modalDialog.showSuccess('Tack!',
                e.successMessage ? e.successMessage : 'Betalningen har nu genomförts och säljaren har meddelats',
                function() { util.redirectTo(e.redirectUrl); });
        }
    } else {

        if (e.paymentFailure && e.paymentFailure.failureResolutionCode === 'ContactYourBank') {
            modalDialog.showError('Ett fel inträffade',
                'Vi kunde inte genomföra betalningen. Kontrollera dina betalningsuppgifter och inställningar. Tänk på att du kan behöva öppna ditt kort för internetköp. Det gör du vanligtvis enkelt på din internetbank.');
        } else if (e.errorMessage) {
            modalDialog.showError('Ett fel inträffade', e.errorMessage);
        } else {
            modalDialog.close();
            util.redirectTo(e.redirectUrl);
        }

        modalDialog.buttons.secondary.click = function() {
            if (e.redirectUrl) {
                util.redirectTo(e.redirectUrl);
            }

            modalDialog.close();

            if (e.paymentFailure) {
                observable.trigger('payment-failed', e.paymentFailure, payment.selectedPaymentType);
            }
        };
    }
};

payment.purchaseFailed = function(modalDialog, e) {
    payment.stopTimeoutHandler();
    modalDialog.showError('Ett fel inträffade', 'Vänligen försök igen');
    util.serverLog({
        error: 'purchaseFailed: ' + JSON.stringify(e)
    });
};

module.exports = payment;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/context/payment.js